export default {
  name: 'ipList',
  props: ['ip_list', 'show_button', 'press', 'type', 'comment', 'lock'],
  components: {},
  data: function () {
  return {
      ip : undefined
    }
  },
  methods: {
    remove(c) { this.$emit('remove', c, this.type); },
    add(c) { this.$emit('add', (c || '').trim(), this.type); this.ip = ''; },
    clear() { this.$emit('clear', this.type); },
  },
  created: function() {   console.log('ipList.vue', 'created'); },
  destroyed: function() { console.log('ipList.vue', 'destroyed'); },
  mounted: function() { console.log('ipList.vue', 'mounted'); }
}